module.exports = __webpack_public_path__ + "static/media/firefox.ecff186b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/firefox.svg
// module id = 2890
// module chunks = 7